<template>
  <el-dialog
    title="选择素材"
    :visible="dialogShow"
    :modal="true"
    append-to-body
    :before-close="onClose"
    width="1000px"
  >
<!--  选择图片素材  -->
<!--    <material-file v-else :fileType="selectType" @selected="onSelect" selectMode></material-file>-->
    <img-or-voice-or-video-material
      :is-select-mode="true"
      :file-type="selectType"
      @selected="onSelect"
    ></img-or-voice-or-video-material>
  </el-dialog>
</template>

<script>
import imgOrVoiceOrVideoMaterial from "../../../../views/wx/accountConfig/materialHome/imgOrVoiceOrVideoMaterial";
export default {
  name: "metarialImgDialog",
  components:{
    imgOrVoiceOrVideoMaterial,
  },
  data(){
    return {

    }
  },
  props:{
    selectType:{// image、voice、video、news
      type:String,
      default:'image'
    },
    dialogShow:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    onSelect(itemInfo){
      this.$emit('selected', itemInfo)
    },
    onClose(){
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
